<template>
  <div
    class="imgs_previews animated"
    @mousewheel.prevent="wheellEvent($event)"
    v-if="isOpen"
  >
    <div class="mask" @click="closeLayer()"></div>
    <img class="close" width="24" height="24" src="/img/icon_close.png" @click="closeLayer()"/>
    <div class="preview_content" @click.stop="closeLayer('mask')">
      <div class="img_list">
          <img :src="mainImg" height="778" />
      </div>
      <div class="thumb_imgs">
        <ul>
          <li
            :class="{select : item.select}"
            @click.stop="changeImg(index)"
            @mouseenter.stop="changeImg(index)"
            v-for="(item, index) in viewsImg"
            :key="index"
          >
            <div class="mask"></div>
            <img :src="item.thumb" width="78" height="60" />
            <p>{{ item.title }}</p>
          </li>
        </ul>
      </div>
      <div class="preview_prev prev_next_btn">
        <img src="/img/aboutUs/icon_arrow_sel@2x.png" @click.stop="prev" width="44" height="44" />
      </div>
      <div class="preview_next prev_next_btn" @click.stop="next">
        <img src="/img/aboutUs/icon_arrow_sel@2x.png" width="44" height="44" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'imagePreview',
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
    imgsList: {
      type: Array,
      default: [],
    },
    pindex: {
      type: Number,
      default: 0,
    },
    maskClose: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      mainImg: '',
      viewsImg: [],
      index: 0,
      len: 0,
    }
  },
  watch: {
    index() {
      this.mainImg = this.viewsImg[this.index].img
    },
  },
  mounted() {
    this.index = this.pindex
    this.imgsList.map((item, index) => {
      // console.log(item)
      let term = {}
      term.select = index == this.index ? true : false
      term.title = item.name
      term.thumb = item.imgUrl
      term.img = item.bigImg
      this.viewsImg.push(term)
    })
    this.mainImg = this.viewsImg[this.index].img
    this.len = this.viewsImg.length

    window.onkeyup = this.keyEvent
  },
  methods: {
    closeLayer(mask) {
      //关闭窗口
      if (mask == 'mask' && !this.maskClose) return
      this.$emit('closeLayer')
    },
    changeImg(index) {
      this.setSelect(index)
      this.index = index
    },
    prev() {
      this.index--
      if (this.index < 0) this.index = this.len - 1
      this.setSelect(this.index)
    },
    next() {
      this.index++
      if (this.index >= this.len) this.index = 0
      this.setSelect(this.index)
    },
    setSelect(index) {
      this.viewsImg.map((item, index) => {
        item.select = false
      })
      this.viewsImg[index].select = true
    },
    wheellEvent(e) {
      e = e || window.event
      if (e.wheelDelta) {
        //判断浏览器IE，谷歌滑轮事件
        if (e.wheelDelta > 0) {
          //当滑轮向上滚动时
          this.prev()
        }
        if (e.wheelDelta < 0) {
          //当滑轮向下滚动时
          this.next()
        }
      } else if (e.detail) {
        //Firefox滑轮事件
        if (e.detail > 0) {
          //当滑轮向上滚动时
          this.prev()
        }
        if (e.detail < 0) {
          //当滑轮向下滚动时
          this.next()
        }
      }
    },
    keyEvent(event) {
      var e = event || window.event || arguments.callee.caller.arguments[0]
      if (e && e.keyCode == 37) {
        //上,左
        this.prev()
      }
      if (e && e.keyCode == 39) {
        //下,右
        this.next()
      }
      if (e && e.keyCode == 27) {
        //ESC
        this.closeLayer()
      }
    },
  },
  destroyed() {
    window.onkeyup = null
  },
}
</script>

<style lang="scss" scoped>
/* 图片预览 */
@mixin flex_center {
  justify-content: center;
}
@mixin flex {
  display: flex;
}
@mixin wh100 {
  width: 100%;
  height: 100%;
}
.imgs_previews {
  position: fixed;
  @include wh100;
  top: 0;
  left: 0;
  z-index: 1998;
  .mask {
    position: absolute;
    @include wh100;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 0;
  }
  .preview_content {
    top: 0;
    border-radius: 2px;
    position: relative;
    .img_list {
      margin: 44px auto 0;
      text-align: center;
      img {
        max-width: 100%;
        max-height: 778px;
      }
    }
  }
  .thumb_imgs {
    z-index: 11;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 98px;
    background: #222;
    @include flex;
    @include flex_center;
    ul {
      overflow-x: scroll;
      display: flex;
      margin-top: 10px;
      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      li {
        width: 78px;
        height: 78px;
        margin-right: 6px;
        position: relative;
        cursor: pointer;
        img {
          height: 60px;
        }
        .mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
        }
        p {
          color: rgba(255, 255, 255, 0.9);
          font-size: 12px;
          text-align: center;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      li.select .mask {
        display: none;
      }
      li:last-child {
        margin-right: 0;
      }
    }
  }
  .close {
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
  }
  .prev_next_btn {
    position: fixed;
    top: 50%;
    width: 44px;
    height: 44px;
    cursor: pointer;
  }
  .preview_prev {
    left: 20px;
  }
  .preview_next {
    right: 20px;
    transform: rotate(180deg);
  }
}
</style>